const APIURL = "https://www.flickr.com/services/rest/"
const APIKEY = process.env.GATSBY_FLICKR_KEY
const APIOWNER = "55409354%40N00"
const IMGSOURCE = "https://live.staticflickr.com/"
const PHOTO = "https://flickr.com/photos/debbiemowry/"

export { APIURL, APIKEY, APIOWNER, IMGSOURCE, PHOTO }
